<template>
  <b-button
    :class="buttonClasses"
    :iconLeft="iconLeft"
    :iconRight="iconRight"
    :type="type"
    :size="size"
    :loading="loading"
    :rounded="rounded"
    :disabled="disabled"
    :outlined="outlined"
    :autofocus="autofocus"
    :tag="tag"
    @click="handleClick"
    @keyup.enter="onEnterKey"
  >
    <slot></slot>
  </b-button>
</template>

<script>
import cn from 'classnames'
export default {
  name: 'AcademyButton',
  props: {
    type: {
      type: String,
      default() {
        return ''
      },
    },
    size: {
      type: String,
      default() {
        return ''
      },
    },
    loading: {
      type: Boolean,
      default() {
        return false
      },
    },
    rounded: {
      type: Boolean,
      default() {
        return false
      },
    },
    disabled: {
      type: Boolean,
      default() {
        return false
      },
    },
    outlined: {
      type: Boolean,
      default() {
        return false
      },
    },
    autofocus: {
      type: Boolean,
      default() {
        return false
      },
    },
    tag: {
      type: String,
      default() {
        return 'button'
      },
    },
    iconLeft: {
      type: String,
      default() {
        return ''
      },
    },
    iconRight: {
      type: String,
      default() {
        return ''
      },
    },
    buttonClass: {
      type: [String, Array],
      default() {
        return ''
      },
    },
    click: {
      type: Function,
      default() {
        return () => {}
      },
    },
    onEnterKey: {
      type: Function,
      default() {
        return () => {}
      },
    },
  },
  computed: {
    buttonClasses() {
      return cn('academy-button', this.buttonClass)
    },
  },
  methods: {
    handleClick() {
      this.$emit('click')
    },
  },
}
</script>

<style lang="scss">
.academy-button {
  min-width: 120px;
  min-height: 40px;
  box-shadow: none;
  font-weight: 600;
  color: #999999;
  > span {
    display: flex;
    align-items: center;
  }
  &.is-grey.is-outlined {
    color: $color-soft-grey;
    &:hover {
      color: #fff;
    }
  }
  &.is-white {
    color: $color-soft-grey;
    background-color: white;
    border: 1px solid $color-soft-grey;
    &:hover,
    &:focus {
      border: 1px solid $color-soft-grey;
      background-color: white;
      color: $color-soft-grey;
      box-shadow: 0 0 4px #858585;
    }
  }
  &.is-green {
    color: #fff;
    background-color: #11b14b;
  }
  &.is-orange {
    color: #fff;
    background-color: #f4811f;
  }
  &.is-light {
    background-color: #f2f2f2;
  }
}
</style>
